import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

// NOTE: This component is deprecated, core component Checkbox should be used instead
export default class FormCheckbox extends React.Component {
  onChange(event) {
    this.props.onChange(event.target.checked);
    const checkBoxValue = event.target.checked ? 'checked' : 'unchecked';
    this.context.i13n.executeEvent('log', {
      label: `${event.target.id} ${checkBoxValue}`,
    });
  }
  render() {
    return (
      <div className={classNames('checkbox', this.props.className)} style={this.props.style}>
        <label>
          <input
            disabled={this.props.disabled}
            type="checkbox"
            value={this.props.value || ''}
            id={this.props.id}
            checked={this.props.value || ''}
            onChange={this.onChange.bind(this)}
          />
          {this.props.children || this.props.label}
        </label>
      </div>
    );
  }
}

FormCheckbox.contextTypes = {
  i13n: PropTypes.object.isRequired,
};
